import { FilterToggleButton, SortToggleButton } from '@/components/custom-elements/searchspring-buttons'
import { useState, useEffect } from 'preact/hooks'
import clsx from 'clsx'

export const CollectionToolbar = () => {
  const [isScrolledPastHalf, setIsScrolledPastHalf] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const halfScreenHeight = window.innerHeight / 2
      setIsScrolledPastHalf(window.scrollY > halfScreenHeight)
    }

    handleScroll()

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="sticky top-full md-max:w-full z-40">
      <div className={clsx(
        'absolute right-margin md:left-1/2 bottom-2 flex md:grid md:grid-cols-2 gap-x-px items-center w-[calc(100%-50px-var(--padding-margin)*3)] md:w-fit md:-translate-x-1/2 transition-all',
        !isScrolledPastHalf && 'md:translate-y-full-margin md:opacity-0',
        isScrolledPastHalf && 'md:translate-y-0 md:opacity-100'
      )}>
        <FilterToggleButton
          className="btn btn-primary btn-fill btn-m w-full md:w-auto md:!rounded-r-none"
          iconClass="w-[12px] h-[8px]"
        />

        <SortToggleButton
          className="md-max:!hidden btn btn-primary btn-fill btn-m w-auto !rounded-l-none"
          iconClass="w-[13px] h-[12px]"
        />
      </div>
    </div>
  )
}
